<template>
    <div class="vx-col md:w-full sm:w-auto">
        <div v-if="params.data.delete != true" class="vx-row md:w-full">
            <vx-tooltip class="position-icon" :text="$t('button.details')" position="top">
                <feather-icon icon="EyeIcon" class="action-success icon-btn"
                              svgClasses="h-5 w-5 hover:text-primary cursor-pointer"
                              @click="editRecord"/>
            </vx-tooltip>

            <vx-tooltip class="position-icon" :text="$t('statusActive.approve')" position="top" v-if="params.data.status == 0 && isPermissionUpdate()">
                <feather-icon icon="CheckIcon" class="action-success icon-btn"
                              svgClasses="h-5 w-5 hover:text-primary cursor-pointer"
                              @click="confirmAcceptLeave"/>
            </vx-tooltip>

            <vx-tooltip class="position-icon" :text="$t('statusActive.decline')" position="top" v-if="params.data.status == 0 && isPermissionUpdate()">
                <feather-icon icon="XIcon" class="action-err icon-btn"
                              svgClasses="h-5 w-5 hover:text-danger cursor-pointer"
                              @click="confirmRejectLeave"/>
            </vx-tooltip>
        </div>
        <vs-popup class="holamundo"  title="Chi tiết khiếu nại" :active.sync="openInOutDetails" v-if="openInOutDetails" id="details-in-out">
            <InOutInformation :inOutId="params.data.id" :branchId="params.data.organizationBranchId"></InOutInformation>
        </vs-popup>
    </div>
</template>

<script>
import moment from 'moment';
import { isAPI, isRouter } from '../../../../store/permission';
import { constAPI, constRouter } from '../../../../store/constant';
import InOutInformation from "../InOutInformation";

export default {
    name: 'CellRendererActions',
    components: {
        InOutInformation
    },
    data() {
        return {
            openInOutDetails: false,
        }
    },
    methods: {
        isPermissionUpdate() {
            return isAPI(this, constAPI.update_in_out_update)
        },
        editRecord() {
            // this.$router.push(`/user/update-in-out-by-id?branch_id=${this.params.data.organizationBranchId}&id=${this.params.data.id}`).catch(() => {
            // })
            this.openInOutDetails = true;
        },
        confirmAcceptLeave() {
            this.$vs.dialog({
                type: 'confirm',
                color: 'danger',
                title: `Xác nhận duyệt`,
                text: `Bạn có chắc là muốn duyệt đơn khiếu nại của nhân viên "${this.params.data.fullName}" không ? `,
                accept: this.acceptLeave,
                acceptText: "Xác nhận",
                cancelText: "Huỷ"
            })
        },
        acceptLeave() {
            let date = this.params.data.date;
            this.$vs.loading();
            let updateInOut = {
                updateInOutId: this.params.data.id,
                employeeWorkShiftByDayId: this.params.data.workShiftId,
                startHour: this.params.data.startHour,
                endHour: this.params.data.endHour,
                employeeId: this.params.data.employeeId,
                organizationBranchId: this.params.data.organizationBranchId,
                fromDate: moment(date).set({hour: 0, minute: 0, second: 0, millisecond: 0}),
                toDate: moment(date).set({hour: 23, minute: 59, second: 59, millisecond: 0}),
                workShiftDetailId: this.params.data.workShiftDetailId
            };
            this.$crm.post('/work-shift/employee/assign-update-in-out/1', updateInOut).then(() => {
                this.$vs.loading.close();
                this.showUpdateSuccess(true);
                this.$store.commit('UPDATE_EMPLOYEE', true);
            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
        },
        confirmRejectLeave() {
            this.$vs.dialog({
                type: 'confirm',
                color: 'danger',
                title: `Xác nhận từ chối`,
                text: `Bạn có chắc là muốn từ chối đơn khiếu nại của nhân viên "${this.params.data.fullName}" không ? `,
                accept: this.acceptCancelLeave,
                acceptText: "Xác nhận",
                cancelText: "Huỷ"
            })
        },
        acceptCancelLeave() {
            this.$vs.loading();
            let updateInOut = {
                updateInOutId: this.params.data.id,
                employeeWorkShiftByDayId: this.params.data.workShiftId,
                fromDate: this.params.data.startHour,
                toDate: this.params.data.endHour,
                employeeId: this.params.data.employeeId,
                organizationBranchId: this.params.data.organizationBranchId
            };
            this.$crm.post('/work-shift/employee/assign-update-in-out/2', updateInOut).then(() => {
                this.$vs.loading.close();
                this.showUpdateSuccess(false);
                this.$store.commit('UPDATE_EMPLOYEE', true);
            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
        },
        showUpdateSuccess(check) {
            this.$vs.notify({
                color: 'success',
                text: check ? 'Duyệt đơn thành công' : 'Từ chối đơn thành công',
                iconPack: 'feather',
                icon: 'icon-alert-circle',
            })
        }
    },

    mounted() {
        this.$eventBus.$on('update-in-out-success', () => {
            this.openInOutDetails = false;
            this.$store.commit('UPDATE_EMPLOYEE', true);
        })
    }
}
</script>
<style lang="scss">
#details-in-out {
    .vs-popup {
        width: 1400px !important;
    }
}
</style>
